import client from './lib/client'

export default { client }




/** WEBPACK FOOTER **
 ** ./index.js
 **/